var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @flow
import { useState } from 'react';
import FormData from 'app/components/Form/FormData/FormData.jsx';
import { ModalConfirmForm } from 'app/components/Modal';
import { ColorPickerPopper } from 'app/components/Form/ColorPicker/ColorPickerPopper.jsx';
import Paper from '@mui/material/Paper';
import { getColorFromBackground } from 'app/libs/helpers/getColorFromBackground.js';
import { sortBy } from 'lodash';
import { useDispatch } from 'react-redux';
import { categoriesAssets, categoriesWithoutAssets } from './Flags';
import { createFlag, updateFlag } from '../../../../store/reducers/reduxFlags';
const EditFlagModal = (props) => {
    const dispatch = useDispatch();
    const { color, flag, category, categories, searchInput } = props, rest = __rest(props, ["color", "flag", "category", "categories", "searchInput"]);
    const [newColor, setNewColor] = useState(color !== null && color !== void 0 ? color : '#DCDCDC');
    const [newCategory, setNewCategory] = useState(category !== null && category !== void 0 ? category : 'article');
    const allCategories = categoriesWithoutAssets.concat(categoriesAssets);
    function onSave(item) {
        return __awaiter(this, void 0, void 0, function* () {
            const editedFlag = {
                id: flag === null || flag === void 0 ? void 0 : flag.id,
                name: item.name,
                description: item.description,
                color: newColor,
                category: flag ? flag.category : newCategory,
            };
            const res = yield dispatch((flag === null || flag === void 0 ? void 0 : flag.id) ? updateFlag(editedFlag) : createFlag(editedFlag));
            return res;
        });
    }
    function onChangeColor(color) {
        return __awaiter(this, void 0, void 0, function* () {
            setNewColor(color);
            return Promise.resolve();
        });
    }
    return (_jsx(ModalConfirmForm, Object.assign({ title: flag && category ? `Update ${categories[category]} flag` : `Create ${category ? categories[category] : ''} flag`, validateLabel: flag ? 'Update flag' : 'Create flag' }, rest, { children: _jsxs(_Fragment, { children: [_jsx(FormData, { properties: [
                        {
                            key: 'name',
                            label: 'Name',
                            type: FormData.types.string,
                            elementProps: { isRequired: true },
                        },
                        {
                            label: 'Category',
                            key: 'category',
                            type: 'select',
                            elementProps: (data, setData) => {
                                console.log('data', data);
                                return {
                                    value: searchInput ? data.category : category,
                                    onChange: (opt) => {
                                        setData(Object.assign(Object.assign({}, data), { category: opt.value }));
                                        setNewCategory(opt.value);
                                    },
                                    options: sortBy(allCategories, ['title']).map((category) => ({
                                        label: category.title,
                                        value: category.category,
                                    })),
                                    disabled: !!category,
                                    placeholder: 'Select a category',
                                };
                            },
                        },
                        {
                            key: 'description',
                            label: 'Description',
                            type: FormData.types.textarea,
                            elementProps: {
                                style: { width: '100%' },
                                rows: 10,
                            },
                        },
                    ], defaultData: flag || { category: newCategory }, onSave: onSave, flashNotifSuccessLabel: `Flag ${flag ? 'updated' : 'created'}` }), _jsx("div", { style: { marginLeft: '15px' }, children: _jsx(Paper, { style: { width: '100px', borderRadius: '10px' }, children: _jsxs("div", { style: {
                                backgroundColor: newColor,
                                color: getColorFromBackground(newColor),
                                borderRadius: '10px',
                                textAlign: 'center',
                                display: 'flex',
                                padding: '0 10px',
                            }, "data-testid": "form-color", children: [newColor, _jsx(ColorPickerPopper, { style: { paddingLeft: '5px', color: getColorFromBackground(newColor) }, color: color, onChange: onChangeColor })] }) }) })] }) })));
};
export default EditFlagModal;
